import { collection, doc, getDoc, getDocs, query } from "firebase/firestore";
import { db } from "./config";

/**
 * Obtiene un documento por ID.
 */
export const getDocument = async (collectionName, id, converter = null) => {
  const docRef = Boolean(converter)
    ? doc(db, collectionName, id).withConverter(converter)
    : doc(db, collectionName, id);
  const docSnap = await getDoc(docRef);
  return docSnap.exists() ? docSnap.data() : null;
};

/**
 * Obtiene todos los documentos de una colección.
 */
export const getCollection = async (
  collectionName,
  converter = null,
  callback
) => {
  if (!callback) return;
  const colRef = Boolean(converter)
    ? collection(db, collectionName).withConverter(converter)
    : collection(db, collectionName);
  const querySnapshot = await getDocs(colRef);
  querySnapshot.forEach((doc) => {
    callback((prev) => [...prev, doc.data()]);
  });
  return;
};

/**
 * Obtiene documentos con condiciones (`where`, `orderBy`, `limit`, etc.).
 */
export const getCollectionWithQuery = async (
  collectionName,
  conditions = [],
  converter = null
) => {
  const colRef = Boolean(converter)
    ? collection(db, collectionName).withConverter(converter)
    : collection(db, collectionName);
  const q = query(colRef, ...conditions);
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((doc) => doc.data());
};
